import { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { TextBox, TextArea } from "@progress/kendo-react-inputs";
import { ProseMirror } from "@progress/kendo-react-editor";
import { GetHtmlFromInfoComponent, GetInfoComponentFromHTML, InfoComponent, infoClassName } from "./InfoComponentTool";

const { DOMParser: DOMParserObj, DOMSerializer: DOMSerializerObj } = ProseMirror;

export const InfoComponentDialog = (props: any) => {
  const [item, setItem] = useState<InfoComponent | undefined>(undefined);
  const [isNew, setIsNew] = useState(false);
  const { nodeAndPos, editorSchema } = props;
  // Read
  useEffect(() => {
    const serializer = DOMSerializerObj.fromSchema(editorSchema);
    const htmlDom = serializer!.serializeNode(nodeAndPos.node);
    let s = new XMLSerializer();
    let htmlContent = s.serializeToString(htmlDom);
    let tagIsNew = false;
    let infoComponent: InfoComponent = new InfoComponent({ title: "", text: "" });
    // New component
    if (
      !nodeAndPos.node.attrs?.class ||
      !nodeAndPos.node.attrs.class.split(" ").includes("str-component-" + infoClassName)
    ) {
      if (nodeAndPos.node.type.isBlock) htmlContent = "";
      infoComponent.title = htmlContent;
      tagIsNew = true;
    } else {
      // Update component
      infoComponent = GetInfoComponentFromHTML(htmlContent);
    }
    setItem(infoComponent);
    setIsNew(tagIsNew);
  }, [nodeAndPos, editorSchema]);

  // Submit
  const submit = (updatedItem: any) => {
    const item = updatedItem as InfoComponent;
    const domParser = new DOMParser();
    // Create a new DOM node from the HTML string
    const domNode = domParser.parseFromString(GetHtmlFromInfoComponent(item), "text/html");
    // Create a new `DOMParser` instance with the schema
    const parser = DOMParserObj.fromSchema(editorSchema);
    // Parse the DOM node and create a ProseMirror node from it
    const newNode = parser.parse(domNode);
    props.onSubmit({ newNode, nodeAndPos });
  };

  // Delete
  const deleteClick = () => {
    props.onSubmit({ htmlContent: "", nodeAndPos });
  };

  return (
    <>
      <Form
        onSubmit={submit}
        ignoreModified={isNew}
        initialValues={item}
        key={JSON.stringify(item)}
        render={(formRenderProps) => {
          return (
            <Dialog title={"Informationsruta"} onClose={props.onCancel} width="80vw" height="450px">
              <FormElement>
                <fieldset className={"k-form-fieldset"}>
                  Titel
                  <Field name={"title"} component={TextBox} label={"Titel"} autoFocus={true} />
                </fieldset>
                <fieldset className={"k-form-fieldset"}>
                  Text
                  <Field name={"text"} component={TextArea} label={"Text"} style={{ height: "200px" }} />
                </fieldset>
              </FormElement>
              <DialogActionsBar>
                <div style={{ textAlign: "right" }}>
                  {!isNew && (
                    <button
                      type="button"
                      className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-danger k-rounded-md"
                      onClick={deleteClick}
                    >
                      Ta bort
                    </button>
                  )}
                  <button
                    type={"button"}
                    onClick={formRenderProps.onSubmit}
                    disabled={!formRenderProps.allowSubmit}
                    className="k-button k-button-md k-button-rectangle k-primary k-button-solid k-button-solid-primary k-rounded-md"
                  >
                    {isNew ? "Lägg till" : "Uppdatera"}
                  </button>
                  <button
                    className="k-button k-button-md k-button-rectangle k-button-solid k-rounded-md k-button-solid-base"
                    onClick={props.onCancel}
                  >
                    Avbryt
                  </button>
                </div>
              </DialogActionsBar>
            </Dialog>
          );
        }}
      />
    </>
  );
};
